import React, { useState } from 'react';
import i18n from 'translations';
import { IDealerTicket } from 'thunks/RTKQuery/dealer';
import { FMCustomerModelComponent } from './component';

interface IDealerDetailModel {
  show: boolean;
  title: string;
  rowItem: IDealerTicket;
  onClose: () => any;
  updateDealerTicketsFMCustomer: (
    rowItem: IDealerTicket,
    fmCustomerId?: string,
    fmCustomerDescription?: string
  ) => void;
}

export const FMCustomerModel = ({
  show,
  title,
  rowItem,
  onClose,
  updateDealerTicketsFMCustomer,
}: IDealerDetailModel) => {
  const [errorString, setErrorString] = useState('');

  return (
    <>
      {errorString && <div className="alert alert-danger">{errorString}</div>}
      <FMCustomerModelComponent
        show={show}
        title={title || i18n.t('dealerManagement.tickets.assignFMCustomer')}
        onClose={onClose}
        rowItem={rowItem}
        setErrorString={setErrorString}
        updateDealerTicketsFMCustomer={updateDealerTicketsFMCustomer}
      />
    </>
  );
};

FMCustomerModel.defaultProps = {};
